import { Grid, Typography } from "@mui/material";
import { FC } from "react";
import { IClubTreasuryOverview } from "../../common/interfaces/club.interface";
import AppCard from "../cards/AppCard";
import ProfitLossChart from "./TreasuryStatistics/ProfitLossChart";
import TotalMoneySpendChart from "./TreasuryStatistics/TotalMoneySpendChart";
import BestNftTradeTable from "./TreasuryStatistics/BestNftTradeTable";
import BuyAndSellsCharts from "./TreasuryStatistics/BuyAndSellsCharts";
import { SOL_USDT } from "../../api/utilities/urls";

const ClubTreasuryOverview: FC<{
  treasuryOverview: IClubTreasuryOverview;
  clubAddress: string;
}> = ({ treasuryOverview, clubAddress }) => {
  return (
    <div>
      <Typography variant="subtitle1" my={1}>
        Treasury and Vault
      </Typography>
      <Grid
        container
        spacing={{ xs: 1, md: 2, sm: 2 }}
        columns={{ xs: 3, sm: 8, md: 8 }}
      >
        <Grid item md={2}>
          <AppCard
            label={"Fundraise info"}
            value={
              treasuryOverview.hasActiveFundraise &&
              treasuryOverview.raisedAmountForFundraise !== 0 &&
              treasuryOverview.raisedAmountForFundraise !== 0
                ? `${treasuryOverview.raisedAmountForFundraise.toString()} / ${treasuryOverview.raisedAmountForFundraise.toString()}`
                : `${(
                    treasuryOverview.totalRaisedAmount * 1000
                  ).toString()} USDC`
            }
          />
        </Grid>
        <Grid item md={2}>
          <AppCard
            label={"Current balance"}
            value={`${(treasuryOverview.balance * 1000).toString()} USDC`}
          />
        </Grid>
        <Grid item md={2}>
          <AppCard
            label={"Financial Account amount"}
            value={treasuryOverview.totalFinancialAccountAmount.toString()}
          />
        </Grid>
        <Grid item md={2}>
          <AppCard
            label={"Total NFT in vault"}
            value={treasuryOverview.totalNumberOfNfts.toString()}
          />
        </Grid>
      </Grid>
      <Typography variant="subtitle2" mt={4}>
        Treasury statistics
      </Typography>
      <Grid
        container
        spacing={{ xs: 1, md: 2, sm: 2 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
        style={{ marginTop: 2 }}
      >
        <Grid item xs={12} sm={12} md={6}>
          <TotalMoneySpendChart clubAddress={clubAddress} />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <BestNftTradeTable clubAddress={clubAddress} />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={{ xs: 1, md: 2, sm: 2 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
        style={{ marginTop: 2 }}
      >
        <BuyAndSellsCharts clubAddress={clubAddress} />
        <Grid item xs={12} sm={12} md={6}>
          <ProfitLossChart clubAddress={clubAddress} />
        </Grid>
      </Grid>
    </div>
  );
};

export default ClubTreasuryOverview;
